<template>
<div class=""  style="padding:0 20px;">

  <el-form ref="formBasic" :model="$abstract.profile.row" @submit.native.prevent="onSubmit" :rules="rules" label-width="180px" style="margin-top:20px;" class="label-30">

   <div class="title_h1 yo-color-primary">TEXT MANAGEMENT</div>
   <div class="yo-text-s yo-color-secondary" style="margin:8px 0 24px 0;">» {{$abstract.profile.row.titolo}}</div>



   <div class="row " style="margin-top:20px;">
 
<!--
      <div class="col s12" v-if="$evento.profile.row.istesto==1">
        <div class="label">Indica il testo del tuo lavoro</div>
        <tinymce v-model="$abstract.profile.row.testo" :initvalue="$abstract.profile.row.testo" height="300" :language="$teras.language" v-on:change="testoChange"> </tinymce>
      </div>
-->

      <div class="col s12" v-if="$evento.profile.row.istesto==0">
        <div class="label">Background and Objectives</div>
        <tinymce v-model="$abstract.profile.row.introduzione" :initvalue="$abstract.profile.row.introduzione" height="300" language="en" v-on:change="introduzioneChange"> </tinymce>
      </div>

      <div class="col s12" style="margin-top:32px;" v-if="$evento.profile.row.istesto==0">
        <div class="label">Material and Methods</div>
        <tinymce v-model="$abstract.profile.row.metodi" :initvalue="$abstract.profile.row.metodi" height="300" language="en" v-on:change="metodiChange"> </tinymce>
      </div>


      <div class="col s12" style="margin-top:32px;" v-if="$evento.profile.row.istesto==0">
        <div class="label">Results</div>
        <tinymce v-model="$abstract.profile.row.risultati" :initvalue="$abstract.profile.row.risultati+' '" height="300" language="en" v-on:change="risultatiChange"> </tinymce>
      </div>

      <div class="col s12" style="margin-top:32px;" v-if="$evento.profile.row.istesto==0">
        <div class="label">Discussion and Conclusion</div>
        <tinymce v-model="$abstract.profile.row.conclusioni" :initvalue="$abstract.profile.row.conclusioni" height="300" language="en" v-on:change="conclusioniChange"> </tinymce>
      </div>


   </div>  


      <div class="row pad help" v-if="wordcount<=$evento.profile.row.maxparole+10" style="color:grey;padding-top:32px;">
         <div class="col s2 yo-align-right"><i class="material-icons" >info</i></div>
         <div class="col s10 yo-text-l" >
            Good, you have used {{wordcount}} words, you still have {{$evento.profile.row.maxparole-wordcount}} 
         </div>
      </div>

      <div class="row pad help" v-if="wordcount>$evento.profile.row.maxparole+10" style="color:red;padding-top:32px;">
         <div class="col s2 yo-align-right"><i class="material-icons" >warning</i></div>
         <div class="col s10 yo-text-l" >
            You have exceeded the maximum number of words allowed which is of: {{$evento.profile.row.maxparole}}    
            <br />
            You can't save your work!
         </div>
      </div>














    <div class="row pad" style="margin-top:20px;border-top:1px solid grey;padding-top:30px;padding-bottom:30px;">
      <div class="col s6 m4 offset-m2">
          <el-button style="width:100%;margin:10px 0;"  @click="onCancel">Cancel</el-button>
      </div>
        
      <div class="col s6 m4 offset-m2" v-if="wordcount<=$evento.profile.row.maxparole+10">
          <el-button type="primary" @click="onSubmit" style="width:100%;background-color:#72BF44;border:none;margin:10px 0;">Save</el-button>
      </div>
    </div>


    </el-form>
<!-- 
<el-button type="primary" @click="emailFirst" style="width:100%;background-color:#72BF44;border:none;margin:10px 0;">Email</el-button>
-->
</div>
</template>

<script>
import tinymce from './Abstract-tinymce.vue'
export default {
  name: 'abstract-testo',
  components: {
      tinymce
  },
  data() {
    return {
      wordTesto:0
      ,wordIntroduzione:0
      ,wordMetodi:0
      ,wordRisultati:0
      ,wordConclusioni:0
    }
  },
  created () {
    if(typeof this.$abstract.profile.row.id == 'undefined'){
      this.$router.push('/home')
    }
    console.log("Arrivo al abstract-testo.vue con id "+this.$abstract.profile.row.id)
  },
  beforeDestroy () {

  },
  methods: {
    testoChange(new_value, wordCount){
      this.wordTesto = wordCount
    },
    introduzioneChange(new_value, wordCount){
      this.wordIntroduzione = wordCount
    },
    metodiChange(new_value, wordCount){
      this.wordMetodi = wordCount
    },
    risultatiChange(new_value, wordCount){
      this.wordRisultati = wordCount
    },
    conclusioniChange(new_value, wordCount){
      console.log("IL NUMERO DI PAROLE: "+new_value+' -> '+wordCount)
      this.wordConclusioni = wordCount
    },
    onCancel() {
      this.$router.push('/home/')
    },
    onSubmit() {
      this.$refs.formBasic.validate(async (valid) => {
        if (valid) {  
         this.Save()
        } else {
          this.$alert('Not all fields have been filled in correctly!', this.$teras.alert_error)
          return false;
        }
      });
    },
    async Save(){
      this.$abstract.profile.row.modificatoil = this.$moment().format('YYYY-MM-DD HH:mm:00')
      this.$abstract.profile.row.wordcount = this.wordcount
      this.$abstract.profile.row.previewil = '0000-00-00 00:00:00'
      this.$abstract.profile.row.preview = ''
      await this.$abstract.profile.save() 
      await this.$contatto.getAbstract() 
      console.log(this.$contatto._abstract)
      this.$router.push('/home/')      
    }

  },
  computed: {
    wordcount:function(){
      if(this.$evento.profile.row.istesto==1){
        return this.wordTesto
      }else{
        return this.wordIntroduzione + this.wordMetodi + this.wordRisultati + this.wordConclusioni
      }
    },

    rules:function() {
      var rulesNow = {
      }
      return rulesNow
    }
  }
}
</script>
<style scoped>
</style>